import React from 'react';
import PropTypes from 'prop-types';

/**
 * Display content of each Tab. The Tabs component can optionally use TabContent.
 * @param {Object} props props
 * @displayName Tab Content
 * @public
 * @returns {React.ReactElement} TabContent
 */
export default function TabContent(props) {
  return (
    <div { ...props }  role='tabpanel' />
  );
}

/**
 * Property validation
 *
 * @type {Object}
 * @api private
 */
TabContent.propTypes = {
  /** Classes to be applied to tab content */
  className: PropTypes.string,
  /** Contents of the tab */
  children: PropTypes.node
};
